import styles from "../styles/ui/CustomButton.module.css";
import Spinner from "./Spinner";

// shape: pill, round
// type: primary, success, secondary, link, dangerous
// variant: filled, outline
// size: sm, md, lg

function CustomButton({
  onClick,
  disabled,
  type = "primary",
  variant = "filled",
  children,
  ...rest
}) {
  const {
    size = "md",
    shape = "pill",
    className = "",
    style = {},
    loading = false,
  } = rest;

  const clickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      onClick={clickHandler}
      className={`${styles.btn} ${styles?.[variant]} ${styles?.[type]} ${styles?.[shape]} ${styles?.[size]} ${className} ${loading ? styles.loading : ""}`}
      style={{ ...style }}
      disabled={disabled}
    >
      {loading && <Spinner />}
      {children}
    </button>
  );
}

export default CustomButton;
